// Copyright 2022, Imprivata, Inc.  All rights reserved.
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';
import './styles/index.less';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './components/app/App';
import { LocaleProvider } from './i18n/localeProvider';
import { minutesToMilliseconds } from './utils/TimeUtils';
import { tracingService } from './tracing';
// Initialize tracing at application startup
tracingService.init();
const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: minutesToMilliseconds(5),
    },
    mutations: {
      retry: 0,
    },
  },
});
// App entrypoint
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<p>Loading...</p>}>
        <LocaleProvider>
          <Router>
            <App />
          </Router>
        </LocaleProvider>
      </Suspense>
    </QueryClientProvider>
  </React.StrictMode>,
);
